import * as Yup from 'yup';

import { validateField, ValidationType } from './formValidation';
import type { NoteFormInterface } from 'types';

export const noteFormDefaultValues: NoteFormInterface = {
    title: '',
    content: '',
};

export const noteFormValidationSchema = Yup.object({
    title: (validateField(ValidationType.STRING) as Yup.StringSchema).max(
        64,
        'Title must be at most 64 characters'
    ),
    content: (validateField(ValidationType.STRING) as Yup.StringSchema).max(
        1024,
        'Content must be at most 1024 characters'
    ),
});
